import { render, staticRenderFns } from "./SolutionsCreate.vue?vue&type=template&id=7476977f&"
import script from "./SolutionsCreate.vue?vue&type=script&lang=js&"
export * from "./SolutionsCreate.vue?vue&type=script&lang=js&"
import style0 from "./SolutionsCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports